import React, { useState } from 'react';
import { X } from 'lucide-react';
import Button from '../ui/Button';
import CustomAlert from '../ui/CustomAlert';

const ProductCard = ({ product, addToCart }) => {
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(product.sizes[0]);
  const [showLightbox, setShowLightbox] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const handleAddToCart = () => {
    const cartItem = {
      ...product,
      selectedSize,
      price: selectedSize.price,
      quantity
    };
    addToCart(cartItem, quantity);
    setShowAlert(true);
  };

  return (
    <>
      <CustomAlert 
        message="Item has been added to your cart!"
        isVisible={showAlert}
        onClose={() => setShowAlert(false)}
      />

      <div className="w-full max-w-xs bg-secondary rounded-lg p-3 sm:p-4 shadow-md">
        <div 
          className="relative cursor-pointer aspect-square mb-2" 
          onClick={() => setShowLightbox(true)}
        >
          <img 
            src={product.image} 
            alt={product.name}
            className="w-full h-full object-cover rounded-md"
          />
          {/* Addding hover effect on the image with the div element below*/}
          <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-10 transition-opacity duration-200 flex items-center justify-center">
          </div>
        </div>

        <h3 className="text-base sm:text-lg font-semibold mb-1">
          {product.name}
        </h3>
        
        <p className="text-gray-600 text-xs sm:text-sm mb-1">
          {product.description}
        </p>
        
        {product.ingredients && (
          <p className="text-gray-600 text-xs sm:text-sm mb-2">
            <span className="font-bold">Key Ingredients:</span> {product.ingredients.join(', ')}
          </p>
        )}
        
        <div className="mb-2">
          <label className="block text-xs sm:text-sm font-medium mb-1">
            Size:
          </label>
          <div className="flex flex-wrap gap-1">
            {product.sizes.map((sizeOption) => (
              <button
                key={sizeOption.size}
                onClick={() => setSelectedSize(sizeOption)}
                className={`px-2 sm:px-3 py-1 rounded-md border text-xs sm:text-sm ${
                  selectedSize.size === sizeOption.size
                    ? 'border-primary-dark bg-emerald-100'
                    : 'border-gray-300 hover:border-primary-dark'
                }`}
              >
                {sizeOption.size}
              </button>
            ))}
          </div>
        </div>
        
        <p className="text-base sm:text-lg font-bold mb-2">
          ₦{selectedSize.price.toLocaleString()}
        </p>
        
        <Button 
          onClick={handleAddToCart}
          variant="accent"
          className="w-full text-xs px-0 md:base sm:text-base py-1.5"
        >
          Add to Cart
        </Button>
      </div>

      {showLightbox && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
          <button 
            onClick={() => setShowLightbox(false)}
            className="absolute top-2 right-2 sm:top-4 sm:right-4 text-white p-1 sm:p-2 hover:bg-white hover:bg-opacity-20 rounded-full"
          >
            <X className="w-4 h-4 sm:w-6 sm:h-6" />
          </button>
          <img 
            src={product.image} 
            alt={product.name}
            className="max-h-[90vh] max-w-[90vw] object-contain"
          />
        </div>
      )}
    </>
  );
};

export default ProductCard;